import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useFormatPriceDifferential } from 'components/common/hooks/useFormatPriceDifferential'
import classNames from 'classnames/bind'
import { CashCreditDifferentialPopover } from './components/cash-credit-differential-popover'
import styles from './CashCreditDifferential.module.scss'

const cx = classNames.bind(styles)

const CashCreditDifferential = ({
  cashCreditDifferential,
  stationId,
  fuelGradeId,
  sliderDispatch,
}) => {
  const { t } = useTranslation()
  const { formatPriceDifferential } = useFormatPriceDifferential()

  const disableSlider = () => {
    sliderDispatch({
      type: 'enabled',
      payload: false,
    })
  }

  const label = cashCreditDifferential
    ? t('widgets.competitorPricing.differenceValue', {
        value: formatPriceDifferential(cashCreditDifferential.differential, 0),
      })
    : t('widgets.competitorPricing.setDifference')

  return (
    <CashCreditDifferentialPopover
      stationId={stationId}
      fuelGradeId={fuelGradeId}
      cashCreditDifferential={cashCreditDifferential}
      sliderDispatch={sliderDispatch}
    >
      <button
        type="button"
        className={cx('spread-button')}
        onClick={disableSlider}
        data-testid="spread-button"
      >
        {label}
      </button>
    </CashCreditDifferentialPopover>
  )
}

CashCreditDifferential.propTypes = {
  cashCreditDifferential: PropTypes.shape(),
  stationId: PropTypes.string.isRequired,
  fuelGradeId: PropTypes.string.isRequired,
  sliderDispatch: PropTypes.func.isRequired,
}

CashCreditDifferential.defaultProps = {
  cashCreditDifferential: null,
}

export { CashCreditDifferential }
